import { Reducer } from 'redux';
import { deepEquals } from 'app/infrastructure/js';
import { CodetableOptions } from './types';
import {
  ACTION, RequestCodetable, ReceiveCodetable, FailCodetable
} from './action-types';

interface CodetableItemState {
  codetableOptions: { [key: string]: CodetableOptions };
}

export const reducers: { [indexer: string]: Reducer<CodetableItemState> } = {

  /**
   * Run when a component wants codetable data
   */
  [ACTION.REQUEST_CODETABLE]: (state: CodetableItemState, action: RequestCodetable): CodetableItemState => {
    return {
      ...state,
      codetableOptions: {
        ...(state.codetableOptions || {}),
        [action.id]: {
          fetching: true,
          loadOptionsParams: action.loadOptionsParams,
          codes: undefined
        }
      }
    };
  },

  /**
   * Run when a component receives its code data
   */
  [ACTION.RECEIVE_CODETABLE]: (state: CodetableItemState, action: ReceiveCodetable): CodetableItemState => {

    if (!state.codetableOptions || !state.codetableOptions[action.id] ||
      !deepEquals(state.codetableOptions[action.id].loadOptionsParams, action.loadOptionsParams)) {
      return state;
    }

    return {
      ...state,
      codetableOptions: {
        ...state.codetableOptions,
        [action.id]: {
          ...state.codetableOptions[action.id],
          fetching: false,
          codes: action.codes
        }
      }
    };
  },

  /**
   * Run when a component fails to download codetable data
   */
  [ACTION.FAIL_CODETABLE]: (state: CodetableItemState, action: FailCodetable): CodetableItemState => {

    if (!state.codetableOptions || !state.codetableOptions[action.id] ||
      !deepEquals(state.codetableOptions[action.id].loadOptionsParams, action.loadOptionsParams)) {
      return state;
    }

    return {
      ...state,
      codetableOptions: {
        ...state.codetableOptions,
        [action.id]: {
          ...state.codetableOptions[action.id],
          fetching: false
        }
      }
    };
  }
};
